import { atom, atomFamily, selector, selectorFamily } from 'recoil';
import { selectedCourseState } from './courses';

export const selectedActivityIdState = atom({
  key: 'selectedActivityIdState',
  default: null,
});

export const selectActivityFromCourseOrderSelector = selectorFamily({
  key: 'selectActivityFromCourseOrderSelector',
  get: (activityToSelectId?) => ({ get }) => {
    get(selectActivityFromCourseOrderSelectorRefresher);

    try {
      const id = activityToSelectId ?? get(selectedActivityIdState);
      if (!id) throw {};

      const course = get(selectedCourseState);
      if (!course) throw {};

      const chapter = null;
      if (!chapter) throw {};

      const [activity] = chapter.activities.filter((act: Activity) => act.id === id);
      if (!activity) throw {};

      return activity;
    } catch {
      return null;
    }
  },
});

export const refreshSelectActivityFromCourseOrderSelector = selector({
  key: 'refreshSelectActivityFromCourseOrderSelector',
  get: ({ get }) => {
    console.error(
      'Using get method for refreshSelectActivityFromCourseOrderSelector. Please import it only using useSetRecoilState'
    );
  },
  set: ({ get, set }) => {
    const count = get(selectActivityFromCourseOrderSelectorRefresher);
    set(selectActivityFromCourseOrderSelectorRefresher, count + 1);
  },
});

const selectActivityFromCourseOrderSelectorRefresher = atom({
  key: 'selectActivityFromCourseOrderSelectorRefresher',
  default: 0,
});

export const selectActivityByIdSelector = atomFamily({
  key: 'selectActivityByIdSelector',
  default: ({ course, activityId }: any) => ({ get }) => {
    if (!course || !activityId) return null;
    for (const chapter of course.course_order.courseChapters) {
      const foundActivity = chapter.activities.find(act => act.id === activityId);
      if (foundActivity) return foundActivity;
    }
    return null;
  },
});
